import React from "react";
import '../../styles/Products.scss';

const ProductTile = (props) => {
    const {product, selectProduct, onLearnMore} = props;
    if (!product) return null;
    return (
        <div className="product-btn">
            <div className="product-heading">
                {product.name}
            </div>
            <div className="title-gradient"/>
            <p style={{
                paddingTop: "3px",
                paddingBottom: "3px",
                fontSize: "12px",
                color: "#858D9D"
            }}>{product.description}</p>

            <div className="flexRow" style={{justifyContent: "space-between"}}>
                <div>
                    <p style={{
                        fontSize: 26,
                        color: "#0A2240",
                        marginBottom: 3
                    }}>R {product.openingDepositCents ? product.openingDepositCents / 100 : ''}</p>
                    <p style={{color: "#858D9D", textTransform: "uppercase", letterSpacing: "1px", fontSize: 9}}>Opening
                        deposit</p>
                </div>
                <div style={{textAlign: "right"}}>
                    <p style={{fontSize: 26, color: "#0A2240", marginBottom: 3}}>Anytime</p>
                    <p style={{
                        color: "#858D9D",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        fontSize: 9
                    }}>Access</p>
                </div>
            </div>
            <div style={{flex: 1}}/>
            <div className="flexRow" style={{alignItems: "flex-end", margin: 0, padding: 0}}>
                {(product.name === "Business Current Account") &&
                <a className="flat-button-primary-light" style={{padding: 0}}
                   onClick={()=>onLearnMore(product.name)}
                   role="button"><span>Learn More</span>
                </a>
                }
                <div style={{flex: 1}}/>
                {
                    product && product.active ?
                        <a className="flat-button-primary" style={{padding: 0}}
                           onClick={() => selectProduct(product.id)}
                           role="button"><span>Apply Now <i className="fa fa-angle-right fa-lg"/> </span>
                        </a>
                        :
                        <a className="flat-button-primary" style={{padding: 0}}><span>Coming Soon</span></a>
                }
            </div>
        </div>
    );
};
export default ProductTile